import { SVGProps } from "react";

export const ActionsIcon = ({ fill, ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.24955 2.92188C5.96167 2.92188 3.02839 5.28509 2.34061 8.50313C1.99699 10.1111 2.22847 11.8209 2.99509 13.2758C3.73291 14.6761 4.94251 15.8077 6.38971 16.4491C7.89505 17.1163 9.62323 17.2326 11.2054 16.7776C12.7318 16.3387 14.0853 15.3755 15.0067 14.0826C16.9332 11.3795 16.6756 7.58261 14.4091 5.16053C13.0807 3.74106 11.1939 2.92188 9.24955 2.92188ZM12.6388 10.3643L10.7128 12.3368C10.2252 12.8363 9.45439 12.0796 9.94003 11.5824L10.9119 10.5872H6.30637C5.97931 10.5872 5.70643 10.3141 5.70643 9.98723C5.70643 9.66035 5.97949 9.38729 6.30637 9.38729H10.8888L9.89773 8.3964C9.40525 7.90391 10.1688 7.14017 10.6613 7.63266L12.6343 9.60545C12.8434 9.81444 12.8454 10.1528 12.6388 10.3643Z"
        fill={fill ?? "#1F1F1F"}
      />
    </svg>
  );
};
